var map = {
	"./css.svg": 617,
	"./email.svg": 88,
	"./email2.svg": 227,
	"./express.svg": 993,
	"./git.svg": 730,
	"./github.svg": 925,
	"./githubCnt.svg": 817,
	"./ham.webp": 596,
	"./html5.svg": 427,
	"./javascript.svg": 642,
	"./linkdin.svg": 294,
	"./mail.png": 188,
	"./mail.svg": 97,
	"./mongodb.svg": 141,
	"./myImg.jpg": 228,
	"./mysql.svg": 87,
	"./nextJs.svg": 283,
	"./nextjs.png": 518,
	"./node.svg": 717,
	"./phone.svg": 759,
	"./portfolio_logo.png": 39,
	"./portfolio_logo2.png": 758,
	"./portfolio_logo3.png": 678,
	"./portfolio_logo4.png": 815,
	"./project1.png": 517,
	"./project2.png": 496,
	"./project3.png": 467,
	"./project4.png": 574,
	"./react.svg": 86,
	"./typescript.svg": 664,
	"./vscode.svg": 180,
	"./youtube.png": 666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 743;